import { memo } from 'react';

// Skeleton para o header do relatório
export const RelatorioHeaderSkeleton = memo(() => {
    return (
        <div className="rounded-3 mb-4">
            <div className="mb-3 d-flex justify-content-between align-items-start">
                <div style={{ flex: 1 }}>
                    <div style={{ width: '60%', height: '32px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div style={{ width: '80%', height: '20px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
                <div className="d-flex gap-2">
                    <div className="btn-group">
                        <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div className="btn btn-outline-primary" style={{ width: '100px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="btn btn-success" style={{ width: '120px', height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
});

RelatorioHeaderSkeleton.displayName = 'RelatorioHeaderSkeleton';

// Skeleton para a seção de filtros
export const RelatorioFiltrosSkeleton = memo(() => {
    return (
        <div className="card mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
            <div className="card-body">
                <div className="row g-3">
                    <div className="col-md-2">
                        <div style={{ width: '60px', height: '16px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div style={{ width: '50px', height: '16px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div style={{ width: '80px', height: '16px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div style={{ width: '70px', height: '16px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '8px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                        <div style={{ width: '100%', height: '38px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                    <div className="col-md-1 d-flex align-items-end">
                        <div className="btn btn-outline-secondary w-100" style={{ height: '38px', backgroundColor: '#e9ecef', border: 'none', position: 'relative' }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

RelatorioFiltrosSkeleton.displayName = 'RelatorioFiltrosSkeleton';

// Skeleton para card de gráfico
const RelatorioCardSkeleton = memo(() => {
    return (
        <div className="col-md-6">
            <div className="card h-100" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                <div className="card-body">
                    <div style={{ width: '80%', height: '24px', backgroundColor: '#e9ecef', borderRadius: '4px', marginBottom: '24px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                    <div style={{ height: '300px', backgroundColor: '#e9ecef', borderRadius: '4px', position: 'relative' }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
});

RelatorioCardSkeleton.displayName = 'RelatorioCardSkeleton';

// Componente que renderiza múltiplos skeletons de cards
export const RelatorioCardsSkeletons = ({ count = 4 }) => {
    const skeletons = Array.from({ length: count }, (_, index) => (
        <RelatorioCardSkeleton key={`skeleton-card-${index}`} />
    ));

    return <>{skeletons}</>;
};

// Componente completo de skeleton para relatórios
export const RelatorioSkeleton = ({ cardCount = 4 }) => {
    return (
        <div className="fade-in w-100 mt-3" style={{ marginBottom: '100px' }}>
            <RelatorioHeaderSkeleton />
            <RelatorioFiltrosSkeleton />
            <div className="row g-4">
                <RelatorioCardsSkeletons count={cardCount} />
            </div>
        </div>
    );
};

export default RelatorioSkeleton;
